<template>
  <v-card v-if="accountData != null" flat class="pa-3 mt-2">
    <v-card-text class="d-flex">
      <!-- upload photo -->
      <div>
        <avatar-image-component :edit="accountData.role == 0" :avatarUrl="accountData.avatar" :user="accountData"></avatar-image-component>
      </div>
    </v-card-text>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        class="multi-col-validation mt-6"
        lazy-validation
      >
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="accountData.name"
              :label="$t('Name')"
              dense
              outlined
              required
              :rules="nameRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.email"
              :label="$t('Email')"
              :disabled="accountData.id != 1"
              dense
              outlined
              required
              :rules="emailRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
            disabled
              v-model="accountData.role"
              dense
              outlined
              :label="$t('Role')"
              :items="roles"
              item-text="role"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              v-model="accountData.status_id"
              :disabled="accountData.id == 1"
              dense
              outlined
              :label="$t('Status')"
              :items="getStatuses()"
              item-text="status"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.tel_number"
              outlined
              dense
              :label="$t('Phone')"
              :rules="phoneRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.wallet"
              outlined
              dense
              :label="$t('Wallet')"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="accountData.role == 2 && accountData.driver_information">
            <v-text-field
              v-model="accountData.driver_information.driver_earning_percentage"
              outlined
              dense
              type="number"
              min="0"
              max="100"
              step="0.01"
              :label="$t('driver_special_earning_percentage')"
              persistent-hint
              :hint="$t('driver_special_earning_percentage_hint')"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" class="me-3 mt-4" @click="saveUser">
                {{ $t("Save Changes") }}
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              @click="cancel"
            >
              {{ $t("cancel") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

import AvatarImageComponent from '../../../components/AvatarImageComponent.vue'
import { mdiAlertOutline, mdiCloudUploadOutline } from "@mdi/js";

export default {
  components: {
    AvatarImageComponent
  },
  props: {
    accountData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    accountData: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.role == 2 && !newVal.driver_information) {
          this.$set(newVal, 'driver_information', { driver_earning_percentage: null });
        }
      }
    }
  },
  data() {
    return {
      valid: true,
      nameRules: [(v) => !!v || this.$t("Name is required")],
      emailRules: [
        v => !!v || this.$t('E-mail is required'),
        v => /.+@.+\..+/.test(v) || this.$t('E-mail must be valid'),
      ],
      phoneRules: [
        v => /^(|\d)+$/.test(v) || this.$t('Phone must be valid'),
      ],
      statuses: [
        { status: "Active", value: 1 },
        { status: "Pending", value: 2 },
        { status: "Suspended", value: 3 },
      ],
      roles: [
        { role: "Admin", value: 0},
        { role: "Customer", value: 1 },
        { role: "Driver", value: 2 },
      ],
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
    };
  },
  methods: {
    getStatuses() {
      return this.statuses.map(status => ({
        status: this.$t(status.status),
        value: status.value
      }));
    },
    validate() {
      return this.$refs.form.validate();
    },
    saveUser() {
      if (!this.validate()) return;
      this.$emit("save-user-info");
    },
    cancel()
    {
      this.$router.go(-1);
    }
  },
};
</script>
